import { render, staticRenderFns } from "./PageStatus.vue?vue&type=template&id=c203d1e0&scoped=true&"
import script from "./PageStatus.vue?vue&type=script&lang=js&"
export * from "./PageStatus.vue?vue&type=script&lang=js&"
import style0 from "./PageStatus.vue?vue&type=style&index=0&id=c203d1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c203d1e0",
  null
  
)

export default component.exports